<template>

    <tr class="align-bottom">
        <td style="width: 60px; max-width: 60px;">
            <v-switch style="margin-top: 12px;" v-model="$props.filter.enabled" color="#c42111" />
        </td>
        <td style="width: 130px; max-width: 130px;">
            <div class="status-text">
                <span style="color: #F44366;" v-if="!$props.filter.valid">Invalid</span>
                <span v-else-if="!$props.filter.enabled">Disabled</span>
                <template v-else>
                    <span class="status-type">Disregarding</span>
                    <span class="status-value" :class="{active: $props.filter.status.length > 0}" @click="viewDisregardedAlarms($props.filter)">{{$props.filter.status.length}}</span>
                    <span> Alarms</span>
                </template>
            </div>
        </td>
        <td style="width: 220px; max-width: 220px;">
            <v-select style="margin-top: 10px; margin-bottom: -10px;" color="#c42111" v-model="filter.property" return-object :items="filterProperties" outlined label="Property" dense @change="filterPropertyChanged" :rules="[$store.state.validationFuncs.required(filter.property, 'Property')]" />
        </td>
        <td style="width: 220px; max-width: 220px;">
            <v-select style="margin-top: 10px; margin-bottom: -10px;" color="#c42111" dense outlined disabled v-if="filter.property.no_method" />
            <v-select style="margin-top: 10px; margin-bottom: -10px;" color="#c42111" v-model="filter.method" :items="filter.property ? filterMethods[filter.property.control] : []" outlined label="Method" dense :disabled="!filter.property" @change="validateFilter" :rules="[$store.state.validationFuncs.required(filter.method, 'Method')]" v-else />
        </td>
        <td>
            <template v-if="filter.property.control == 'multi_select'">
                <v-select style="margin-top: 10px; margin-bottom: -10px;" color="#c42111" outlined dense multiple v-model="filter.value" :items="$props.filterValueLists[filter.property.value]" @change="validateFilter" :rules="[$store.state.validationFuncs.requiredList(filter.value, 'Value')]" />
            </template>
            <template v-else-if="filter.property.control == 'yes_no'">
                <v-select style="margin-top: 10px; margin-bottom: -10px;" color="#c42111" outlined dense v-model="filter.value" :items="yes_no_values" @change="validateFilter" :rules="[$store.state.validationFuncs.requiredNotNullOrUndefined(filter.value, 'Value')]" />
            </template>
            <template v-else-if="filter.property.control == 'datetime'">
                <v-row v-if="filter.method == 'inRange'">
                    <v-col cols="6">
                        <v-datetime-picker color="#c42111" label="Date From" outlined dense v-model="$props.filter.value.dateFrom" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="dtPickerTextProps" @change="validateFilter" />
                    </v-col>
                    <v-col cols="6">
                        <v-datetime-picker color="#c42111" label="Date To" outlined dense v-model="$props.filter.value.dateTo" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="dtPickerTextProps" @change="validateFilter" />
                    </v-col>
                </v-row>
                <v-datetime-picker color="#c42111" label="After Date" outlined dense v-model="$props.filter.value.dateFrom" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="dtPickerTextProps" @change="validateFilter" v-else-if="$props.filter.method == 'greaterThan'" />
                <v-datetime-picker color="#c42111" label="Before Date" outlined dense v-model="$props.filter.value.dateTo" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="dtPickerTextProps" @change="validateFilter" v-else-if="$props.filter.method == 'lessThan'" />
            </template>
            <template v-else>
                <v-text-field style="margin-top: 10px; margin-bottom: -10px;" color="#c42111" v-model="$props.filter.value" outlined label="Value" dense :rules="[$store.state.validationFuncs.required($props.filter.value, 'Value')]" />
            </template>
        </td>
        <td style="vertical-align: middle; width: 80px; max-width: 80px;">
            <v-icon x-large color="#F44336" style="cursor: pointer;" @click="$emit('delete', $props.index)">mdi-delete-forever</v-icon>
        </td>


        <v-dialog v-model="showDisregardedAlarmsList" max-width="80%" width="1200px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showDisregardedAlarmsList = false : null}">
            <disregarded-alarms-list v-if="showDisregardedAlarmsList" :alarms="disregardedAlarmsListFilter.status" :alarmGridResources="$props.alarmGridResources" @close="showDisregardedAlarmsList = false" />
        </v-dialog>


    </tr>

</template>

<script>
import { VForm } from 'vuetify/lib'
import DisregardedAlarmsList from "@/components/GeoMap/DisregardedAlarmsList";
export default {
    extends: VForm,
    name: 'AdvancedFilter',
    props: ['filter', 'index', 'filterValueLists', 'alarmGridResources'],
    components: {
        DisregardedAlarmsList
    },
    data: () => ({
        // filterBehaviors: [
        //     {text: 'Disregard Alarm', value: 'disregard'}
        // ],
        filterProperties: [
            {text: 'Acked', value: 'alarm_acked', no_method: true, control: 'yes_no'},
            {text: 'Description', value: 'alarm_description', control: 'text'},
            //{text: 'Duplicate', value: 'alarm_is_dupe', control: 'bool_yes_no'},
            {text: 'Local Time', value: 'alarm_local_time', control: 'datetime'},
            {text: 'Locale', value: 'site_locale', control: 'multi_select'}, 
            {text: 'Severity', value: 'alarm_severity', control: 'multi_select'},
            {text: 'Service Affecting', value: 'alarm_service_affecting', no_method: true, control: 'yes_no'},
            {text: 'Time', value: 'alarm_time', control: 'datetime'}, 
        ],
        filterMethods: {
            yes_no: [
                {text: 'Yes', value: 'yes'},
                {text: 'No', value: 'no'}
            ],
            bool_yes_no: [
                {text: 'Yes', value: 'yes'},
                {text: 'No', value: 'no'}
            ],
            text: [
               {text: 'Contains', value: 'contains'},
               {text: 'Not Contains', value: 'notContains'},
               {text: 'Equals', value: 'equals'},
               {text: 'Not Equals', value: 'notEquals'},
               {text: 'Starts With', value: 'startsWith'},
               {text: 'Ends With', value: 'endsWith'}
            ],
            multi_select: [
               {text: 'Contains', value: 'contains'},
            ],
            datetime: [
                {text: 'Before', value: 'lessThan'},
                {text: 'After', value: 'greaterThan'},
                {text: 'Range', value: 'inRange'},
            ]
        },
        yes_no_values: [
            {text: 'Yes', value: true},
            {text: 'No', value: false},
        ],

        showAlarmFilterViews: false,

        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111'
        },
        dpProps: {
            color: '#c42111'
        },
        dtPickerTextProps: {
            dense: true,
            outlined: true,
            color: "#c42111",
            style: "margin-top: 10px; margin-bottom: -10px;",
        },


        showDisregardedAlarmsList: false,
        disregardedAlarmsListFilter: null

    }),

    computed: {

    },

    methods: {
        filterPropertyChanged: function() {
            this.$props.filter.method = null;
            this.$props.filter.value = null;
            if(this.$props.filter.property.control == 'datetime') {
                this.$props.filter.value = {dateFrom: null, dateTo: null};
            }
        },

        validateFilter: function() {
            return;
            this.$nextTick(() => {
                console.log('WATCH FUNC');
                this.$props.filter.valid = this.validate();
            });
        },

        viewDisregardedAlarms: function(filter) {
            console.log('view disregarded alarms: ', filter.status);
            this.disregardedAlarmsListFilter = filter;
            this.showDisregardedAlarmsList = true;
        }
    },

    watch: {
        filter: {
            handler(newVal, oldVal) {
                this.$nextTick(() => {
                    console.log('WATCH FUNC');
                    this.$props.filter.valid = this.validate();
                });
                
            },
            deep: true
        }
    },

    created() {
        this.dtPickerTextProps.rules = [(value) => {return this.$store.state.validationFuncs.required(value, 'Value')}]; // Add this on create because we need access to store.

        if(this.$props.filter.property.control == 'datetime') {
            if(this.$props.filter.value.dateFrom) {
                //console.log(this.$props.filter.value.dateFrom);
                this.$props.filter.value.dateFrom = TELSA.moment(this.$props.filter.value.dateFrom).isValid() ? TELSA.moment(this.$props.filter.value.dateFrom).format('YYYY-MM-DD HH:mm:ss') : null;
            }
            if(this.$props.filter.value.dateTo) {
                //console.log(this.$props.filter.value.dateTo);
                this.$props.filter.value.dateTo = TELSA.moment(this.$props.filter.value.dateTo).isValid() ? TELSA.moment(this.$props.filter.value.dateTo).format('YYYY-MM-DD HH:mm:ss') : null;
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.$props.filter.valid = this.validate();
            console.log('FILTER: ', this.$props.filter);
        });
    }

  
};
</script>

<style scoped>

    .status-text {
        display: block;
    }

    .status-text .status-type {
        display: block;
    }

    .status-text .status-value {
        font-weight: bold;
        color:coral;
    }
    .status-text .status-value.active {
        cursor: pointer;
        text-decoration: underline;
    }

</style>
